import React, { Component } from 'react';
import './tech.scss';

import InfoCard from '../../components/info-card/info-card';

class App extends Component {

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="tech">

        <div className="header">
          <div className="title-container">
            <h1 className="title" data-aos="fade-down" data-aos-duration="1000">We are the best because we use the best!</h1>
            <h3 className="subtitle" data-aos="fade-up" data-aos-delay="1000" data-aos-duration="1000">We use the latest and greatest technology to build the best results for you.</h3>
          </div>
        </div>
        <div className="main-content">
          <div className="section">
            <div className="content-header">
              <div>
                <h1 className="title">Mobile App Development</h1>
                <div className="center">
                  <p className="description">
                    Either it's just your idea, rough sketches or well-defined strategy with designs ready.
                    We're ready to build the mobile app out of it.
                    The guru programmers build the end product keeping the new technology in mind and work accordingly to face new challenges.
                    For Android and iOS mobile apps we provide flexible and effective back-end as well as front-end coding.
                  </p>
                </div>
              </div>
            </div>
            <div className="cards">
              <InfoCard
                backgroundColor="white"
                cardImg={require('../../assets/xcode.png')}
                cardTitle="Xcode"
                cardText="Xcode is an IDE developed by Apple to develop iOS applications."
              />
              <InfoCard
                backgroundColor="white"
                cardImg={require('../../assets/swift-logo.png')}
                cardTitle="Swift"
                cardText="Swift is our language of choice when developing native iOS applications."
              />
              <InfoCard
                backgroundColor="white"
                cardImg={require('../../assets/android-studio-logo.svg')}
                cardTitle="Android Studio"
                cardText="Android Studio is an IDE developed by Google and JetBrains to develop Android applications."
              />
              <InfoCard
                backgroundColor="white"
                cardImg={require('../../assets/java-logo.png')}
                cardTitle="Java"
                cardText="Java is the language used to develop native Android appliations."
              />
              <InfoCard
                backgroundColor="white"
                cardImg={require('../../assets/react-logo.png')}
                cardTitle="React Native"
                cardText="React Native is developed by Facebook to develop iOS and Android applications using the same code."
              />
              <InfoCard
                backgroundColor="white"
                cardImg={require('../../assets/firebase-logo.png')}
                cardTitle="Firebase"
                cardText="Firebase is an all-in-one mobile backend allowing users to login to apps and save data."
              />
              <InfoCard
                backgroundColor="white"
                cardImg={require('../../assets/nodejs-logo.png')}
                cardTitle="Node.js"
                cardText="Node.js is a framework we use to build APIs to make a mobile backend for mobile applications."
              />
            </div>
          </div>
          <div className="section">
            <div className="content-header">
              <div>
                <h1 className="title">Web Development</h1>
                <div className="center">
                  <p className="description">
                    Either it's about giving your product or business digital presence or developing the custom SaaS solution; we cover almost everything to convince the users to stay on the website which is dynamic, effective and mobile responsive. Because a well-executed idea can be the game changer!
                  </p>
                </div>
              </div>
            </div>
            <div className="cards">
              <InfoCard
                backgroundColor="white"
                cardImg={require('../../assets/django.png')}
                cardTitle="Django"
                cardText="Django is a Python based framework used to develop web applications."
              />
              <InfoCard
                backgroundColor="white"
                cardImg={require('../../assets/react-logo.png')}
                cardTitle="React"
                cardText="React is a JavaScript library maintained by Facebook used to build web applications."
              />
              <InfoCard
                backgroundColor="white"
                cardImg={require('../../assets/wordpress.png')}
                cardTitle="Wordpress"
                cardText="Wordpress is a php framework that allows us to give our clients control over their own content."
              />
              <InfoCard
                backgroundColor="white"
                cardImg={require('../../assets/php-logo.png')}
                cardTitle="PHP"
                cardText="PHP is a server-side scripting language designed for web development."
              />
              <InfoCard
                backgroundColor="white"
                cardImg={require('../../assets/asp-net-logo.png')}
                cardTitle="ASP.NET"
                cardText="ASP.NET is a server-side scripting language based on C# designed for web development."
              />
              <InfoCard
                backgroundColor="white"
                cardImg={require('../../assets/javascript-logo.png')}
                cardTitle="JavaScript"
                cardText="JavaScript allows for interactive web pages that perform tasks without reloading the page."
              />
              <InfoCard
                backgroundColor="white"
                cardImg={require('../../assets/postgres-logo.png')}
                cardTitle="PostgreSQL"
                cardText="PostgreSQL is a relational database that stores user data and can be installed on multiple systems."
              />
              <InfoCard
                backgroundColor="white"
                cardImg={require('../../assets/mysql-logo.png')}
                cardTitle="MySQL"
                cardText="MySQL is a relational database that stores user data and is backed by Oracle."
              />
            </div>
          </div>
          <div className="section">
            <div className="content-header">
              <div>
                <h1 className="title">Web Hosting</h1>
                <div className="center">
                  <p className="description">
                    Leveraging the cloud, we provide a web hosting enviornment tailored to your mobile/web app. Our dedicated team ensures your hosting environment stays up and running through the night so your customers never see an outage.
                  </p>
                </div>
              </div>
            </div>
            <div className="cards">
              <InfoCard
                backgroundColor="white"
                cardImg={require('../../assets/aws-logo.png')}
                cardTitle="Amazon Web Services"
                cardText="AWS is a cloud platform that provides the best enviornment for web hosting."
              />
              <InfoCard
                backgroundColor="white"
                cardImg={require('../../assets/ubuntu-logo.png')}
                cardTitle="Ubuntu"
                cardText="Ubuntu is a free and open source operating system based on Linux."
              />
              <InfoCard
                backgroundColor="white"
                cardImg={require('../../assets/nginx-logo.png')}
                cardTitle="Nginx"
                cardText="Nginx is a linux web server that connects the world to your web and mobile applications."
              />
              <InfoCard
                backgroundColor="white"
                cardImg={require('../../assets/apache-logo.png')}
                cardTitle="Apache"
                cardText="Apache is a linux web server that connects the world to your web and mobile applications."
              />
              <InfoCard
                backgroundColor="white"
                cardImg={require('../../assets/windows-logo.png')}
                cardTitle="Windows Server"
                cardText="Windows Server is just like Windows used on desktops but has more features."
              />
              <InfoCard
                backgroundColor="white"
                cardImg={require('../../assets/iis-logo.png')}
                cardTitle="Microsoft IIS"
                cardText="IIS is a Windows based web server that connects the world to your web and mobile applications."
              />
              <InfoCard
                backgroundColor="white"
                cardImg={require('../../assets/lets-encrypt-logo.svg')}
                cardTitle="Let's Encrypt"
                cardText="Let's Encrypt provides free SSL certificates to provide secure connections to your hosting enviornment."
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/pages/tech/tech.js